import { RestClient } from './RestClient'
import store from '../store'

export class SearchClient extends RestClient {
  /**
   * SearchClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}`
  }

  /**
   * @param {string} query - Search query
   */
  search (query) {
    this.params.q = query

    return this.call('get', `${this.baseUrl}/search`)
  }

  suggest () {
    return this.call('get', `${this.baseUrl}/suggest`)
  }
}
